export const initialStatePageKey = 'crehanaApp';
export const COURSE_DETAIL_PAGE_KEY = 'course-detail';
